/**
 * @class Mutation
 * @property {string} id Unique id
 * @property {string} name Name
 * @property {boolean} default Is this a default mutation?
 * @property {string} code Mutation code
 * @property {boolean} enabled Is this mutation enabled?
 * @this Mutation
 */
export default class Mutation {

	/**
	 * @return {Mutation}
	 */
	static normalize(data) {
		return Object.assign(new Mutation(), data);
	}
}



// WEBPACK FOOTER //
// ./models/Mutation.js